// apps/app/src/main.tsx

import { StrictMode, Suspense } from 'react';
import { createRoot } from 'react-dom/client';
import { QueryClientProvider } from '@tanstack/react-query';
import { BrowserRouter } from 'react-router-dom';
import { App } from './App';
import { queryClient } from './lib/query-client';
// Before anything renders, so the first paint is already in their language.
import './lib/i18n';
import '@fontsource-variable/inter';
import './styles.css';

const container = document.getElementById('root');
if (!container) throw new Error('No #root element');

createRoot(container).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      {/* Navigation as a transition: while the next page's chunk loads, the
          current page stays on screen instead of collapsing to the skeleton. */}
      <BrowserRouter future={{ v7_startTransition: true }}>
        {/* Waits for the language's text before the first paint — a frame of
            English flashing before German is worse than a blank one. */}
        <Suspense fallback={null}>
          <App />
        </Suspense>
      </BrowserRouter>
    </QueryClientProvider>
  </StrictMode>,
);
